import request from '@/utils/request'

/**
 * 账号登录
 *
 * @export
 * @param {*} usr
 * @param {*} pwd
 * @returns
 */
export function login(usr, pwd) {
  return request({
    url: `/Api/Account/Login?username=${usr}&password=${pwd}`,
    method: 'post'
  })
}

/**
 * 发送验证码
 *
 * @export
 * @returns
 * @param phone
 */
export function sendRegisterCode(phone) {
  return request({
    url: `/Api/Account/SendRegisterCode?phone=${phone}`,
    method: 'post'
  })
}

/**
 * 账号注册
 *
 * @export
 * @returns
 * @param form
 */
export function register(form) {
  return request({
    url: '/Api/Account/Register',
    method: 'post',
    data: form
  })
}

/**
 * 注册验证
 *
 * @export
 * @param {number} 手机号
 * @param {number} 验证码
 * @returns
 */
export function verify(phone, code) {
  return request({
    url: `/Api/Account/Register/Verify?phone=${phone}&code=${code}`,
    method: 'post'
  })
}

/**
 * 发送找回密码验证码
 *
 * @export
 * @param {*}
 * @param {*}
 * @returns
 */
export function sendFindPasswordCode(phone) {
  return request({
    url: `/Api/Account/SendFindPasswordCode?phone=${phone}`,
    method: 'post'
  })
}

/**
 * 重置账号新密码
 *
 * @export
 * @param {*}
 * @param {*}
 * @returns
 */
export function resetPassword(data) {
  return request({
    url: `/Api/Account/ResetPassword?code=${data.code}&phone=${data.phone}&password=${data.password}`,
    method: 'post'
  })
}

/**
 * 微信授权跳转地址
 *
 * @export
 * @param {*} path 回调页面地址 例:[/Account/WXReturn]
 * @returns
 */
export function getWeChatCodeAuthorizeUrl(path) {
  return request({
    url: `/Api/Account/WeChatCodeAuthorizeUrl?redirectUri=${encodeURIComponent(location.origin + path)}`,
    method: 'get'
  })
}

/**
 * 微信授权登录
 *
 * @export
 * @param {*} code
 * @returns
 */
export function weChatLogin(code) {
  return request({
    url: `/Api/Account/WeChatLogin?code=${code}`,
    method: 'get'
  })
}

/**
 * 绑定微信
 *
 * @export
 * @param {*} code
 * @returns
 */
export function bindWeChat(code) {
  return request({
    url: `/Api/Account/BindWeChat?code=${code}`,
    method: 'post'
  })
}

/**
 * 解除绑定微信
 *
 * @export
 * @returns
 */
export function unBindWeChat() {
  return request({
    url: '/Api/Account/UnbindWeChat',
    method: 'post'
  })
}
